export const returnInspectionReasonLabel = (value: unknown): string => {
  if (typeof value === 'string' && value.trim()) return value;
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const reason = value as { label?: unknown; code?: unknown };
    if (typeof reason.label === 'string' && reason.label.trim()) return reason.label;
    if (typeof reason.code === 'string' && reason.code.trim()) return reason.code;
  }
  return 'Inspection required';
};
